import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Provider.List.IRequest;
type Response = Api.Core.Provider.List.IResponse;
type Headers = Api.Core.Provider.List.IHeaders;
const url = '/api/ProductManagement/Provider';
export default async function providerListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
